import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteTenant } from "Infrastructure/Api/Api";
import { getTenantsQueryKey } from "Tenants/Api/Queries/useTenantsQuery";

export function useDeleteTenantMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id: number) => deleteTenant(id),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [getTenantsQueryKey(0, 100)],
			});
		},
	});
}
